<template>
  <div>
    <h3>Вырезка с начала месяца, врачи</h3>
    <p class="text-xs-right" v-if="data.lastUpdate"><i class="fas fa-clock"></i> {{ data.lastUpdate }}</p>
    <v-data-table
      :headers="headers"
      :items="data.data"
      :loading="data.inProgress"
      :hide-actions="true"
      no-data-text="Статистика недоступна"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <tr>
          <td>{{ props.item.name }}</td>
          <td><b>{{ props.item.casesCount }}</b></td>
          <td><b>{{ props.item.avgCasesCount }}</b></td>
          <td><b>{{ props.item.histoblocksCount }}</b></td>
          <td><b>{{ props.item.avgHistoblocksCount }}</b></td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'GrossingByDoctors',
  props: {
    data: {
      Type: Object
    }
  },
  data () {
    return {
      headers: [
        {
          text: 'ФИО',
          align: 'left',
          sortable: false,
          value: 'name',
          width: '100px'
        },
        {
          text: 'Случаев',
          sortable: false,
          value: 'casesCount',
          width: '50px'
        },
        {
          text: 'Среднее за день',
          sortable: false,
          value: 'avgCasesCount',
          width: '50px'
        },
        {
          text: 'Гистоблоков',
          sortable: false,
          value: 'histoblocksCount',
          width: '50px'
        },
        {
          text: 'Среднее за день',
          sortable: false,
          value: 'avgHistoblocksCount',
          width: '50px'
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Walldash/GrossingByDoctors.vue